import GlobalAxios from "../axios/axios-config";

const CHANGE_PIN_ROUTE =
  process.env.REACT_APP_IDENTIY + "/api/v1/Users/ChangeCurrentUserPin";

export interface IChangePin {
  newPin: string;
}

export class ChangePinService {
  create = (item: IChangePin) => {
    return GlobalAxios.post(CHANGE_PIN_ROUTE, item);
  };
}

export default ChangePinService;
